"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions2 = require("egov-ui-kit/redux/form/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "propertyAreaDetails",
  fields: {
    coveredSpaceArea: {
      id: "coveredSpaceArea",
      jsonPath: "Properties[0].propertyDetails.coveredSpaceArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) {
          //  remove disabled field
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceUnit", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceType", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceUnit", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceType", "disabled", false));
          }

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");

          var coveredValue = field.value + "-" + properties[0].propertyDetails.coveredSpaceUnit + "-" + properties[0].propertyDetails.coveredSpaceType;

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpace", coveredValue));
        }
      }
    },
    coveredSpaceUnit: {
      id: "coveredSpaceUnit",
      jsonPath: "Properties[0].propertyDetails.coveredSpaceUnit",
      type: "singleValueList",
      floatingLabelText: "",
      value: "",
      disabled: true,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");

          var coveredValue = properties[0].propertyDetails.coveredSpaceArea + " + " + field.value + " + " + properties[0].propertyDetails.coveredSpaceType;

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpace", coveredValue));
        }
      }
    },
    coveredSpaceType: {
      id: "coveredSpaceType",
      jsonPath: "Properties[0].propertyDetails.coveredSpaceType",
      type: "singleValueList",
      floatingLabelText: "",
      disabled: true,
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");

          var coveredValue = properties[0].propertyDetails.coveredSpaceArea + "-" + properties[0].propertyDetails.coveredSpaceUnit + "-" + field.value;

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpace", coveredValue));
        }
      }
    },
    openCarParkingArea: {
      id: "openCarParkingArea",
      jsonPath: "Properties[0].propertyDetails.openCarParkingArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingUnit", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingType", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingUnit", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingType", "disabled", false));
          }

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");

          var openCarParking = field.value + "-" + properties[0].propertyDetails.openCarParkingUnit + "-" + properties[0].propertyDetails.openCarParkingType;

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParking", openCarParking));
        }
      }
    },
    openCarParkingUnit: {
      id: "openCarParkingUnit",
      jsonPath: "Properties[0].propertyDetails.openCarParkingUnit",
      type: "singleValueList",
      floatingLabelText: "",
      disabled: true,
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var openCarParking = properties[0].propertyDetails.openCarParkingArea + "-" + field.value + "-" + properties[0].propertyDetails.openCarParkingType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParking", openCarParking));
        }
      }
    },
    openCarParkingType: {
      id: "openCarParkingType",
      jsonPath: "Properties[0].propertyDetails.openCarParkingType",
      type: "singleValueList",
      floatingLabelText: "",
      disabled: true,
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var openCarParking = properties[0].propertyDetails.openCarParkingArea + "-" + properties[0].propertyDetails.openCarParkingUnit + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParking", openCarParking));
        }
      }
    },
    coveredCarParkingArea: {
      id: "coveredCarParkingArea",
      jsonPath: "Properties[0].propertyDetails.coveredCarParkingArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingUnit", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingType", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingUnit", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingType", "disabled", false));
          }

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var coveredCarParking = field.value + "-" + properties[0].propertyDetails.coveredCarParkingUnit + "-" + properties[0].propertyDetails.coveredCarParkingType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParking", coveredCarParking));
        }
      }
    },
    coveredCarParkingUnit: {
      id: "coveredCarParkingUnit",
      jsonPath: "Properties[0].propertyDetails.coveredCarParkingUnit",
      type: "singleValueList",
      disabled: true,
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",

      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var coveredCarParking = properties[0].propertyDetails.coveredCarParkingArea + "-" + field.value + "-" + properties[0].propertyDetails.coveredCarParkingType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParking", coveredCarParking));
        }
      }
    },
    coveredCarParkingType: {
      id: "coveredCarParkingType",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.coveredCarParkingType",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var coveredCarParking = properties[0].propertyDetails.coveredCarParkingArea + "-" + properties[0].propertyDetails.coveredCarParkingUnit + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParking", coveredCarParking));
        }
      }
    },
    openTerraceArea: {
      id: "openTerraceArea",
      jsonPath: "Properties[0].propertyDetails.openTerraceArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",

      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaUnit", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaType", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaUnit", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaType", "disabled", false));
          }

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var openTerrace = field.value + "-" + properties[0].propertyDetails.openTerraceAreaUnit + "-" + properties[0].propertyDetails.openTerraceAreaType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerrace", openTerrace));
        }
      }
    },
    openTerraceAreaUnit: {
      id: "openTerraceAreaUnit",
      jsonPath: "Properties[0].propertyDetails.openTerraceAreaUnit",
      type: "singleValueList",
      floatingLabelText: "",
      disabled: true,
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref11) {
        var formKey = _ref11.formKey,
            field = _ref11.field,
            dispatch = _ref11.dispatch,
            state = _ref11.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceAreaUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var openTerrace = properties[0].propertyDetails.openTerraceArea + "-" + field.value + "-" + properties[0].propertyDetails.openTerraceAreaType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerrace", openTerrace));
        }
      }
    },
    openTerraceAreaType: {
      id: "openTerraceAreaType",
      jsonPath: "Properties[0].propertyDetails.openTerraceAreaType",
      type: "singleValueList",
      floatingLabelText: "",
      disabled: true,
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref12) {
        var formKey = _ref12.formKey,
            field = _ref12.field,
            dispatch = _ref12.dispatch,
            state = _ref12.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceAreaType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var openTerrace = properties[0].propertyDetails.openTerraceArea + "-" + properties[0].propertyDetails.openTerraceAreaUnit + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerrace", openTerrace));
        }
      }
    },
    commonSpaceArea: {
      id: "commonSpaceArea",
      jsonPath: "Properties[0].propertyDetails.commonSpaceArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref13) {
        var formKey = _ref13.formKey,
            field = _ref13.field,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceUnit", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceType", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceUnit", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceType", "disabled", false));
          }

          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var commonSpace = field.value + "-" + properties[0].propertyDetails.commonSpaceUnit + "-" + properties[0].propertyDetails.commonSpaceType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpace", commonSpace));
        }
      }
    },
    commonSpaceUnit: {
      id: "commonSpaceUnit",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.commonSpaceUnit",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref14) {
        var formKey = _ref14.formKey,
            field = _ref14.field,
            dispatch = _ref14.dispatch,
            state = _ref14.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var commonSpace = properties[0].propertyDetails.commonSpaceArea + "-" + field.value + "-" + properties[0].propertyDetails.commonSpaceType;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpace", commonSpace));
        }
      }
    },
    commonSpaceType: {
      id: "commonSpaceType",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.commonSpaceType",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref15) {
        var formKey = _ref15.formKey,
            field = _ref15.field,
            dispatch = _ref15.dispatch,
            state = _ref15.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var commonSpace = properties[0].propertyDetails.commonSpaceArea + "-" + properties[0].propertyDetails.commonSpaceUnit + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpace", commonSpace));
        }
      }
    },

    roofArea: {
      id: "roofArea",

      jsonPath: "Properties[0].propertyDetails.roofArea",
      type: "textfield",
      floatingLabelText: "",
      hintText: "Enter area",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref16) {
        var formKey = _ref16.formKey,
            field = _ref16.field,
            dispatch = _ref16.dispatch,
            state = _ref16.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofType", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofUnit", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofType", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofUnit", "disabled", false));
          }
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var roof = field.value + "-" + properties[0].propertyDetails.roofType + "-" + properties[0].propertyDetails.roofUnit;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roof", roof));
        }
      }
    },
    roofType: {
      id: "roofType",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.roofType",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref17) {
        var formKey = _ref17.formKey,
            field = _ref17.field,
            dispatch = _ref17.dispatch,
            state = _ref17.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var roof = properties[0].propertyDetails.roofArea + "-" + field.value + "-" + properties[0].propertyDetails.roofUnit;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roof", roof));
        }
      }
    },
    roofUnit: {
      id: "roofUnit",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.roofUnit",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref18) {
        var formKey = _ref18.formKey,
            field = _ref18.field,
            dispatch = _ref18.dispatch,
            state = _ref18.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var roof = properties[0].propertyDetails.roofArea + "-" + properties[0].propertyDetails.roofType + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roof", roof));
        }
      }
    },

    swimmingPoolArea: {
      id: "swimmingPoolArea",
      jsonPath: "Properties[0].propertyDetails.swimmingPoolArea",
      type: "textfield",
      hintText: "Enter area",
      floatingLabelText: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref19) {
        var formKey = _ref19.formKey,
            field = _ref19.field,
            dispatch = _ref19.dispatch,
            state = _ref19.state;

        if (field.value) {
          if (field.value == "") {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolType", "disabled", true));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolUnit", "disabled", true));
          } else {
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolType", "disabled", false));
            dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolUnit", "disabled", false));
          }
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolArea", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var swimmingPool = field.value + "-" + properties[0].propertyDetails.swimmingPoolType + "-" + properties[0].propertyDetails.swimmingPoolUnit;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPool", swimmingPool));
        }
      }
    },
    swimmingPoolType: {
      id: "swimmingPoolType",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.swimmingPoolType",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "small",
        label: "Small"
      }, {
        value: "medium",
        label: "Medium"
      }, {
        value: "big",
        label: "Big"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref20) {
        var formKey = _ref20.formKey,
            field = _ref20.field,
            dispatch = _ref20.dispatch,
            state = _ref20.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolType", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var swimmingPool = properties[0].propertyDetails.swimmingPoolArea + "-" + field.value + "-" + properties[0].propertyDetails.swimmingPoolUnit;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPool", swimmingPool));
        }
      }
    },
    swimmingPoolUnit: {
      id: "swimmingPoolUnit",
      disabled: true,
      jsonPath: "Properties[0].propertyDetails.swimmingPoolUnit",
      type: "singleValueList",
      floatingLabelText: "",
      dropDownData: [{ value: "", label: "Select" }, {
        value: "sqMt",
        label: "Sq Mt"
      }, {
        value: "sqCm",
        label: "Sq Cm"
      }, {
        value: "sqFt",
        label: "Sq Ft"
      }],
      value: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref21) {
        var formKey = _ref21.formKey,
            field = _ref21.field,
            dispatch = _ref21.dispatch,
            state = _ref21.state;

        if (field.value) {
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolUnit", field.value));
          var properties = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.Properties");
          var swimmingPool = properties[0].propertyDetails.swimmingPoolArea + "-" + properties[0].propertyDetails.swimmingPoolUnit + "-" + field.value;
          dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPool", swimmingPool));
        }
      }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var state = store.getState();
    var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");

    if (data && data.length > 0) {
      var propertyDetails = data[0].propertyDetails;

      if (propertyDetails && Object.keys(propertyDetails).length > 0) {
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceArea", "value", propertyDetails.coveredSpaceArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceUnit", "value", propertyDetails.coveredSpaceUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceType", "value", propertyDetails.coveredSpaceType.toString()));

        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingArea", "value", propertyDetails.openCarParkingArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingUnit", "value", propertyDetails.openCarParkingUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingType", "value", propertyDetails.openCarParkingType.toString()));

        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingArea", "value", propertyDetails.coveredCarParkingArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingUnit", "value", propertyDetails.coveredCarParkingUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingType", "value", propertyDetails.coveredCarParkingType.toString()));

        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceArea", "value", propertyDetails.openTerraceArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaUnit", "value", propertyDetails.openTerraceAreaUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaType", "value", propertyDetails.openTerraceAreaType.toString()));

        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceArea", "value", propertyDetails.commonSpaceArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceUnit", "value", propertyDetails.commonSpaceUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceType", "value", propertyDetails.commonSpaceType.toString()));

        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofArea", "value", propertyDetails.roofArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofType", "value", propertyDetails.roofType.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofUnit", "value", propertyDetails.roofUnit.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolArea", "value", propertyDetails.swimmingPoolArea.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolType", "value", propertyDetails.swimmingPoolType.toString()));
        dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolUnit", "value", propertyDetails.swimmingPoolUnit.toString()));

        // check whether the value exist or not otherwise disable the field
        if (propertyDetails.coveredSpaceArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceUnit", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredSpaceType", "disabled", false));
        }
        if (propertyDetails.openCarParkingArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingUnit", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openCarParkingType", "disabled", false));
        }
        if (propertyDetails.coveredCarParkingArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingUnit", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "coveredCarParkingType", "disabled", false));
        }
        if (propertyDetails.openTerraceArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaUnit", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaType", "disabled", false));
        }

        if (propertyDetails.commonSpaceArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "commonSpaceUnit", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "openTerraceAreaType", "disabled", false));
        }
        if (propertyDetails.roofArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofType", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "roofUnit", "disabled", false));
        }
        if (propertyDetails.swimmingPoolArea != "") {
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolType", "disabled", false));
          dispatch((0, _actions2.setFieldProperty)("propertyAreaDetails", "swimmingPoolUnit", "disabled", false));
        }

        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceArea", propertyDetails.coveredSpaceArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceUnit", propertyDetails.coveredSpaceUnit.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredSpaceType", propertyDetails.coveredSpaceType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingArea", propertyDetails.openCarParkingArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingUnit", propertyDetails.openCarParkingUnit.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openCarParkingType", propertyDetails.openCarParkingType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingArea", propertyDetails.coveredCarParkingArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingUnit", propertyDetails.coveredCarParkingUnit.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.coveredCarParkingType", propertyDetails.coveredCarParkingType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceArea", propertyDetails.openTerraceArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceAreaUnit", propertyDetails.openTerraceAreaUnit.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.openTerraceAreaType", propertyDetails.openTerraceAreaType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceArea", propertyDetails.commonSpaceArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceUnit", propertyDetails.commonSpaceUnit.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.commonSpaceType", propertyDetails.commonSpaceType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofArea", propertyDetails.roofArea ? propertyDetails.roofArea.toString() : ""));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofType", propertyDetails.roofType ? propertyDetails.roofType.toString() : ""));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roofUnit", propertyDetails.roofUnit ? propertyDetails.roofUnit.toString() : ""));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolArea", propertyDetails.swimmingPoolArea.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolType", propertyDetails.swimmingPoolType.toString()));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.swimmingPoolUnit", propertyDetails.swimmingPoolUnit.toString()));
      }
    }

    return action;
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayMutation/propertyAreaDetails.js
// module id = 2071
// module chunks = 1137